import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

export interface WorkOrderPermissions {
  userId: string | null;
  canView: boolean;
  canManage: boolean;
  canApprove: boolean;
}

/** What the signed-in user may be offered on a work order. UX only: the server decides, and separation of duties is checked there too. */
export function useWorkOrderPermissions(): WorkOrderPermissions {
  const { state } = useCurrentUser();
  if (state.status !== 'authenticated') return { userId: null, canView: false, canManage: false, canApprove: false };
  const { permissions, id } = state.user;
  return {
    userId: id,
    canView: permissions.includes('maintenance.view'),
    canManage: permissions.includes('workorder.manage'),
    canApprove: permissions.includes('workorder.approve'),
  };
}
